import { createAsyncThunk } from '@reduxjs/toolkit';
import { get } from '../models/base';

export const fetchReferralUsage = createAsyncThunk(
  'referral/fetchReferralUsage',
  async (_, { rejectWithValue }) => {
    try {
      const response = await get('/api/referral_usages');
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);
